import { useCallback } from "react";

import { useMutationWithState } from "hooks";

export function useUpdateClientComment(commentGid) {
  const mutationFactory = useCallback(() => {
    const query = `mutation updateComment($commentGid: ID!, $content: String!) {
        updateComment(commentGid: $commentGid, content: $content) {
            successMessage
        }
    }`;

    const resolver = ({ data, errors }) => {
      return {
        data: data.createComment,
        errors: errors,
      };
    };

    return { query, resolver };
  }, []);

  const [mutation, { errors, loading }] = useMutationWithState(mutationFactory);

  return {
    updatingErrors: errors,
    isUpdatingComment: loading,
    updateComment: async (content) => {
      return mutation({
        commentGid: commentGid,
        content: content,
      });
    },
  };
}

export default useUpdateClientComment;
